import React from 'react';

import classNames from 'classnames';

import ContentListItem from 'CommonComponents/ContentListItem';

export default function ContentList({ list, bordered, children }) {
    return (
        <div className={classNames('tw-rounded-lg', { 'tw-border-2 tw-border-gray-200 tw-p-2.5': bordered })}>
            <ul className="tw-flex tw-flex-col tw-gap-y-3 tw-text-sm">
                {children ? children : Object.entries(list || {})?.map(([key, value]) => <ContentListItem key={key} title={key} content={value} />)}
            </ul>
        </div>
    );
}
